import axios            from "axios";

const axiosStore = () => {
  const csrf_token = document.querySelector('meta[name="csrf-token"]').content;
  let custom_headers = {}
  if(csrf_token) custom_headers['X-CSRF-Token'] = csrf_token
  const client = axios.create({
    headers: custom_headers,
  });
  return client;
}

export const getBom = async (bom_id) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/${bom_id}`
  return client.get(url).then(response => response.data)
}

export const doQuoteBomStatus = async (bom_id) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/${bom_id}/status`
  try {
    return (await client.get(url));
  } catch (err) {
    throw err
  }
}

export const createBom = async (data) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/`

  try {
    return (await client.post(url, data));
  } catch (err) {
    throw err
  }
}

export const saveBomOnStore = async (bom_id, data) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/${bom_id}/save`
  return client.post(url, data).then(response => response.data)
}

export const updateBomVersion = async (bom_id, data) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/${bom_id}`
  return client.put(url, data).then(response => response.data)
}

export const getBomLineItemSubstitutes = async (bom_line_item_id) => {
  const client = axiosStore()
  const url = `${Spree.routes.bom_quotes_url}/${bom_line_item_id}/substitutes`
  return client.get(url).then(response => response.data)
}

export const searchSubstitutes = async (bom_line_item_id, keyword, quote_number) => {
  const client = axiosStore()
  let url = `${Spree.routes.bom_quotes_url}/${bom_line_item_id}/search?keyword=${keyword}`
  if(quote_number) url += `&quote_number=${quote_number}`
  return client.get(url).then(response => response.data)
}